import { VirtualBoardView } from "../Views";

export const VirtualBoardPage = (props: { location: any }) => {
	return <VirtualBoardView location={props.location} />;
};
